import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { OPTION_PICKER_BASE_CLASSNAME } from './Constants';
import { createOptionPicker } from './OptionPicker';
createComponents(".".concat(OPTION_PICKER_BASE_CLASSNAME), createOptionPicker, NO_PATTERN_BUSINESS_LOGIC);
